<template>
    <BasicPage title="特商法に基づく表示" class="page">
        <BasicArticle>
            <h2>事業者名</h2>
            <p>株式会社Aerial Partners</p>

            <h2>所在地</h2>
            <p>東京都港区六本木五丁目2番1号　ほうらいやビル４F</p>

            <h2>運営統括責任者</h2>
            <p>代表取締役　沼澤 健人</p>

            <h2>お問い合わせ先</h2>
            <p>
                メール： contact@aerial-p.com<br />
                電話: 上記メールアドレスにてご請求いただいた場合は遅滞なく開示いたします。
            </p>

            <h2>利用料金</h2>
            <p>サービスごとに販売価格を設定し、該当ページで表示します。</p>

            <h2>その他お客様の負担する費用</h2>
            <p>お客様が契約した各事業者が定める通信料等</p>

            <h2>利用料金の支払時期及び方法</h2>
            <p>サービスごとに支払時期および方法を指定し、該当ページで表示します。</p>

            <h2>サービスの提供時期</h2>
            <p>サービスごとに提供時期を指定し、該当ページで表示します。</p>

            <h2>返品の取扱条件／返品期限、返品時の送料負担または解約や退会条件</h2>
            <p>サービスごとに当社指定の手続きにより解約可能です。 既に支払われた分に対する返金はお受けできません。</p>
        </BasicArticle>
    </BasicPage>
</template>

<script>
import BasicPage from '@/components/BasicPage.vue';
import BasicArticle from '@/components/layout/BasicArticle.vue';

export default {
    components: { BasicPage, BasicArticle },
    layout: 'default',
};
</script>
